import { Organisation, OrganisationUsers } from '@lune-fe/dapi-models'
import { useQuery, useQueryClient } from 'react-query'

import { getOrganisation, getOrganisationUsers } from '../endpoints/dapi'
import { queryKeys } from '../queryKeys'

import useAccounts from './useAccounts'

const useActiveOrganisation = () => {
    const reactQueryClient = useQueryClient()
    const { activeAccount } = useAccounts()
    const organisationId = activeAccount?.organisationId

    const { isLoading: loadingOrg, data: activeOrg } = useQuery<Organisation>(
        [queryKeys.GET_ORGANISATION, organisationId],
        () => {
            return getOrganisation(organisationId!)
        },
        {
            enabled: !!organisationId,
        },
    )

    const { isLoading: loadingOrgUsers, data: organisationUsers } = useQuery<OrganisationUsers>(
        [queryKeys.GET_ORGANISATION_USERS, organisationId],
        () => getOrganisationUsers(organisationId!),
        {
            enabled: !!organisationId,
        },
    )

    const activeOrgUsers = organisationUsers?.users
    const activeOrgInvites = organisationUsers?.invites

    return {
        loadingActiveOrg: loadingOrg && loadingOrgUsers,
        refetchActiveOrg: () => {
            reactQueryClient.invalidateQueries(queryKeys.GET_ORGANISATION)
            reactQueryClient.invalidateQueries(queryKeys.GET_ORGANISATION_USERS)
        },
        activeOrg,
        activeOrgUsers,
        activeOrgInvites,
    }
}

export default useActiveOrganisation
